var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "join-row-wrap"
  }, [_c('div', {
    staticClass: "join-row join-row--form"
  }, [_vm._m(0), _c('div', {
    staticClass: "board-table board-table--input",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('input-row', {
    attrs: {
      "label": "아이디"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.username,
      expression: "user.username"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "username"
    },
    domProps: {
      "value": _vm.user.username
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "비밀번호"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.password,
      expression: "user.password"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": _vm.user.password
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value);
      }, _vm.input]
    }
  }), _c('p', {
    staticClass: "d-block text-grey mt-4 font-size-10 font-size-lg-12"
  }, [_vm._v("* (영문대소문자/숫자/특수문자 조합, 8 - 16자)")])]), _c('input-row', {
    attrs: {
      "label": "비밀번호 확인"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.passwordConfirm,
      expression: "user.passwordConfirm"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "password2",
      "type": "password"
    },
    domProps: {
      "value": _vm.user.passwordConfirm
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "passwordConfirm", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "기업명"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.companyName,
      expression: "user.companyName"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "companyName"
    },
    domProps: {
      "value": _vm.user.companyName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "companyName", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "대표자명"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.ceoName,
      expression: "user.ceoName"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "ceoName"
    },
    domProps: {
      "value": _vm.user.ceoName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "ceoName", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "기업설립일"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.establishedAt,
      expression: "user.establishedAt"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "date",
      "name": "establishedAt"
    },
    domProps: {
      "value": _vm.user.establishedAt
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "establishedAt", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "사업자등록번호"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.businessNumber,
      expression: "user.businessNumber"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "businessNumber",
      "maxlength": "10"
    },
    domProps: {
      "value": _vm.user.businessNumber
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "businessNumber", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "연락처"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone1,
      expression: "user.phone1"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "tel",
      "name": "phone1",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone1
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone1", $event.target.value);
      }, _vm.input]
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone2,
      expression: "user.phone2"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "tel",
      "name": "phone2",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone2
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone2", $event.target.value);
      }, _vm.input]
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone3,
      expression: "user.phone3"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "tel",
      "name": "phone3",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone3
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone3", $event.target.value);
      }, _vm.input]
    }
  })])], 1)], 1), _c('input-row', {
    attrs: {
      "label": "이메일"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email1,
      expression: "user.email1"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "name": "email1"
    },
    domProps: {
      "value": _vm.user.email1
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email1", $event.target.value);
      }
    }
  })]), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("@")]), _c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email2,
      expression: "user.email2"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "name": "email2"
    },
    domProps: {
      "value": _vm.user.email2
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email2", $event.target.value);
      }
    }
  })]), _c('v-col', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email3,
      expression: "user.email3"
    }],
    staticClass: "select w-100",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.user, "email3", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        _vm.user.email2 = _vm.user.email3;
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("직접입력")]), _c('option', {
    domProps: {
      "value": "naver.com"
    }
  }, [_vm._v("naver.com")]), _c('option', {
    domProps: {
      "value": "daum.net"
    }
  }, [_vm._v("daum.net")]), _c('option', {
    domProps: {
      "value": "google.com"
    }
  }, [_vm._v("google.com")])])])], 1)], 1), _c('input-row', {
    attrs: {
      "label": "주소"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.postcode,
      expression: "user.postcode"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "placeholder": "우편번호",
      "readonly": ""
    },
    domProps: {
      "value": _vm.user.postcode
    },
    on: {
      "click": _vm.onSearchPostcode,
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "postcode", $event.target.value);
      }
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "auto",
      "sm": "2"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 h-100 input-btn",
    attrs: {
      "block": "",
      "elevation": "0",
      "dark": "",
      "color": "grey-dark"
    },
    on: {
      "click": _vm.onSearchPostcode
    }
  }, [_c('span', [_vm._v("검색")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.address1,
      expression: "user.address1"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "placeholder": "기본주소",
      "readonly": ""
    },
    domProps: {
      "value": _vm.user.address1
    },
    on: {
      "click": _vm.onSearchPostcode,
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "address1", $event.target.value);
      }
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.address2,
      expression: "user.address2"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "placeholder": "상세주소"
    },
    domProps: {
      "value": _vm.user.address2
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "address2", $event.target.value);
      }
    }
  })])], 1)], 1), _c('input-row', {
    attrs: {
      "label": "관심분야"
    }
  }, [_c('v-row', _vm._l(_vm.areas, function (parent) {
    return _c('v-col', {
      key: parent._id,
      attrs: {
        "cols": "6",
        "lg": ""
      }
    }, [_c('v-row', [_c('v-col', [_vm._v(_vm._s(parent.name))])], 1), _vm._l(parent.children, function (child) {
      return _c('v-row', {
        key: child._id
      }, [_c('v-col', [_c('v-checkbox', {
        staticClass: "my-0 py-0",
        attrs: {
          "label": child.name,
          "value": child._id,
          "hide-details": "",
          "dense": ""
        },
        on: {
          "input": _vm.input
        },
        model: {
          value: _vm.user._areas,
          callback: function callback($$v) {
            _vm.$set(_vm.user, "_areas", $$v);
          },
          expression: "user._areas"
        }
      })], 1), child.name == '기타(입력)' && _vm.user._areas.includes(child._id) ? _c('v-col', {
        staticClass: "pt-0",
        attrs: {
          "cols": "12"
        }
      }, [_c('v-text-field', {
        staticClass: "my-0 py-0",
        attrs: {
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: _vm.user.areas_manual[parent._id],
          callback: function callback($$v) {
            _vm.$set(_vm.user.areas_manual, parent._id, $$v);
          },
          expression: "user.areas_manual[parent._id]"
        }
      })], 1) : _vm._e()], 1);
    })], 2);
  }), 1)], 1)], 1)])]), _c('div', {
    staticClass: "join-row-wrap"
  }, [_vm._m(1), _c('div', {
    staticClass: "board-table board-table--input",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('input-row', {
    attrs: {
      "label": "홈페이지 주소"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.website,
      expression: "user.website"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "website"
    },
    domProps: {
      "value": _vm.user.website
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "website", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "담당자정보"
    }
  }, [_c('div', {
    staticClass: "row row--small"
  }, [_c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "이름",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.workerName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerName", $$v);
      },
      expression: "user.workerName"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "직책",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.workerTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerTitle", $$v);
      },
      expression: "user.workerTitle"
    }
  })], 1)])]), _c('input-row', {
    attrs: {
      "label": "주요생산제품"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.mainProduct,
      expression: "user.mainProduct"
    }],
    staticClass: "w-100",
    domProps: {
      "value": _vm.user.mainProduct
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "mainProduct", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "기업개요"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.summary,
      expression: "user.summary"
    }],
    domProps: {
      "value": _vm.user.summary
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "summary", $event.target.value);
      }, _vm.input]
    }
  })]), _c('input-row', {
    attrs: {
      "label": "기업로고"
    }
  }, [_c('v-file-input', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "accept": "image/*"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.avatar,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "avatar", $$v);
      },
      expression: "user.avatar"
    }
  })], 1), _c('form-files', {
    attrs: {
      "label": "소개자료"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.brochures,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "brochures", $$v);
      },
      expression: "user.brochures"
    }
  })], 1)])])]), _c('div', {
    staticClass: "button-group"
  }, [_c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "large": "",
      "outlined": "",
      "rounded": "",
      "color": "grey",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.cancel();
      }
    }
  }, [_c('span', {
    staticClass: "color-grey"
  }, [_vm._v("취소하기")])]), _c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "large": "",
      "rounded": "",
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.submit();
      }
    }
  }, [_c('span', [_vm._v("회원가입")])])], 1), _c('daum-postcode', {
    ref: "daum-postcode",
    on: {
      "change": function change(_ref) {
        var postcode = _ref.postcode,
          address = _ref.address;
        _vm.user.postcode = postcode;
        _vm.user.address1 = address;
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-caption join-caption--center"
  }, [_c('h3', {
    staticClass: "text-20 text-lg-18"
  }, [_vm._v("회원정보 필수입력")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-caption join-caption--center"
  }, [_c('h3', {
    staticClass: "text-20 text-lg-18"
  }, [_vm._v("회원정보 선택입력")])]);
}]

export { render, staticRenderFns }